import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoute } from '@enums';
import { AuthService } from '@services';
import { WINDOW } from 'moddy/common';

export function authGuard(): CanActivateFn {
    return (): boolean => {
        const authService = inject(AuthService);
        const router = inject(Router);
        const window = inject(WINDOW);

        if (!authService.isAuthorized()) {
            router.navigateByUrl(`/${AppRoute.Root.Auth}?url=${window.location.href}`);
        }

        return authService.isAuthorized();
    };
}
